export default __webpack_public_path__ + "static/media/HO.1860ed03.jpg";